import { Flex, Text, Switch } from '@mantine/core';
import { QueryKey } from '@shared/config';
import { showNotification } from '@shared/utils';
import dayjs from 'dayjs';
import { useQueryClient } from '@tanstack/react-query';
import {
  useUpdateVacancyTemplateActivity,
  type VacancyTemplate,
} from '@entities/vacancy';

type VacanciesTemplateHeaderProps = {
  isActive: boolean;
  id: number;
  createdAt: string;
  updatedAt: string;
};

export const VacanciesTemplateHeader = ({
  isActive,
  id,
  createdAt,
  updatedAt,
}: VacanciesTemplateHeaderProps) => {
  const queryClient = useQueryClient();

  const { mutate: updateActivityVacancyTemplate, isPending } =
    useUpdateVacancyTemplateActivity(id);

  const handleChangeActivity = (value: boolean) => {
    updateActivityVacancyTemplate(
      { isActive: value },
      {
        onSuccess: data => {
          queryClient.setQueryData(
            [QueryKey.GET_VACANCY_TEMPLATE, id],
            (prevData: VacancyTemplate) => ({
              ...prevData,
              ...data,
            })
          );
        },
        onError: error => {
          showNotification({
            error,
            variant: 'error',
            message:
              error.response?.data.message ||
              'Не удалось изменить активность шаблона',
          });
        },
      }
    );
  };

  return (
    <Flex align='center' w='100%' justify='space-between' wrap='wrap'>
      <Flex wrap='wrap' rowGap={16} columnGap={32} align='center'>
        <Flex gap={12} align='center'>
          <Text size='sm'>Активность:</Text>
          <Switch
            checked={isActive}
            onChange={event => handleChangeActivity(event.target.checked)}
            label={isActive ? 'Активен' : 'Неактивен'}
            disabled={isPending}
          />
        </Flex>

        <Flex gap={8}>
          <Text size='sm' c='tertiary.7'>
            ID:
          </Text>
          <Text size='sm' c='primary.7'>
            {id}
          </Text>
        </Flex>

        <Flex gap={8}>
          <Text size='sm' c='tertiary.7'>
            Дата создания:
          </Text>
          <Text size='sm' c='primary.7'>
            {dayjs(createdAt).format('DD.MM.YYYY, HH:mm')}
          </Text>
        </Flex>

        <Flex gap={8}>
          <Text size='sm' c='tertiary.7'>
            Дата изменения:
          </Text>
          <Text size='sm' c='primary.7'>
            {dayjs(updatedAt).format('DD.MM.YYYY, HH:mm')}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
